import React from 'react';

// Fondo estático de líneas de circuito (mismo lenguaje visual del logo de
// Orbiax), muy sutil, reemplaza la foto de oficina para no competir
// visualmente con la mascota.
const CircuitBackground = () => {
  return (
    <div className="fixed inset-0 z-0 overflow-hidden bg-white" aria-hidden="true">
      <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="circuit-tile" width="140" height="140" patternUnits="userSpaceOnUse">
            <g stroke="#C7D2FE" strokeWidth="1.2" fill="none" opacity="0.55">
              <path d="M0 30 H50 V70 H90" />
              <path d="M140 100 H100 V60 H60" />
              <path d="M20 140 V110 H70 V0" />
            </g>
            <g fill="#A5B4FC" opacity="0.7">
              <circle cx="50" cy="30" r="2.2" />
              <circle cx="90" cy="70" r="2.2" />
              <circle cx="100" cy="100" r="2.2" />
              <circle cx="60" cy="60" r="2.2" />
              <circle cx="70" cy="110" r="2.2" />
              <circle cx="70" cy="0" r="2.2" />
            </g>
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#circuit-tile)" />
      </svg>
    </div>
  );
};

export default CircuitBackground;
